import { type FunctionComponent, cloneElement } from 'react';
import { useRemoveGeorole } from '@data/georole-mutations';
import { StructParams } from '@lib/structures';
import { Person } from '@domain/person';

interface RemoveGeoroleProps {
  button: JSX.Element;
  person: Person;
  roleName: string;
  structures: StructParams[];
}

const RemoveGeorole: FunctionComponent<RemoveGeoroleProps> = props => {
  const { button, person, roleName, structures } = props;

  const [removeGeorole, { loading }] = useRemoveGeorole();

  const handleClick = () => {
    removeGeorole(person.idnumber, roleName, structures);
  };

  return cloneElement(button, { isLoading: loading, onClick: handleClick });
};

export default RemoveGeorole;
